// src/app/shared/pipes/can-module.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { AuthzService } from '../../core/services/company-admin/authz.service';
import { ModuleKey, ModuleIds } from '../../core/constants/module-ids';

@Pipe({ name: 'canModule', pure: false })
export class CanModulePipe implements PipeTransform {
  constructor(private authz: AuthzService) {}

  transform(
    module: number | ModuleKey,
    action: string | string[]
  ): boolean {
    const id = typeof module === 'number' ? module : ModuleIds[module];
    if (Array.isArray(action)) return this.authz.canAnyModule(id, action);
    return this.authz.canModule(id, action);
  }
}
